<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <detail-dialog ref="detailDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/worder/complete/list";
import detailDialog from "@/components/mall/worder/complete/detailDialog";

export default {
  name: "worder_complete",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
  },
  methods: {
    details(row) {
      this.$refs.detailDialog.openDetails(row);
    },
  },
};
</script>